// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../../assets/DropDownArrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-wrapper {
  width: 70%;
  padding-bottom: 9rem;
  padding-top: 5rem;
  position: relative;
}
.form-outer-wrapper {
  width: 70%;
  margin-top: 3rem;
}
.form-outer-wrapper form {
  width: 100%;
}
.form-wrapper form .row {
  margin-bottom: 3rem;
}
.form-wrapper form .row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.form-field {
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  column-gap: 4rem;
  position: relative;
}
.form-field select{
  -webkit-appearance: none;
}
.form-field select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 10px center;
  background-repeat: no-repeat;          
  background-size: 10px 6px;             
}
.name,
.email,
.country {
  width: 100%;
}
.form-wrapper form .row:nth-child(3) > div,
.form-wrapper form .row:nth-child(4) > div {
  width: 48%;
}
.heading-inner {
  margin-top: 2.5rem;
}
.heading-inner h2 {
  font-size: 2.2rem;
  font-weight: 500;
}
.questions-wrapper {
  padding: 3rem 0;
  overflow-y: auto;
  height: 66%;
}
.schedule-demo-wrapper {
  height: 100%;
}
.schedule-demo-top {
  display: flex;
  border-bottom: 1px solid #9a9a9a33;
}
.schedule-demo-left {
  width: 74%;
}
.schedule-demo-right {
  width: 26%;
  margin-top: 1rem;
}
@media (min-width: 1850px) {
  .form-outer-wrapper form {
    width: 70%;
  }
}
@media (max-width: 1440px) {
  .schedule-demo-left {
    width: 72%;
  }
  .schedule-demo-right {
    width: 28%;
  }
  .form-wrapper {
    width: 68%;
  }
  .form-outer-wrapper {
    width: 80%;
  }
}
@media (max-width: 1024px) {
  .schedule-demo-top {
    flex-direction: column;
  }
  .schedule-demo-left {
    width: 100%;
  }
  .schedule-demo-top {
    padding-bottom: 2rem;
  }
  .schedule-demo-right {
    width: 100%;
    margin-top: 0;
  }
  .form-outer-wrapper {
    width: 88%;
  }
}

@media (max-width: 768px) {
  .form-wrapper {
    margin-top: 3rem;
    width: 100%;
    padding-top: 0;
  }

  .form-outer-wrapper .row {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 2rem;
    margin-bottom: 2rem !important;
  }
  .form-outer-wrapper {
    width: 100%;
  }
  .form-outer-wrapper .row:nth-child(3) > div,
  .form-outer-wrapper .row:nth-child(4) > div {
    width: 100% !important;
  }
}
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.timezone-wrapper {
  margin: 3rem;
  padding: 20px;
  border: 1px solid #093179;
  text-align: center;
  padding: 14px 8px;
  border-radius: 12px;
}
.timezone-wrapper p {
  font-weight: 600;
  color: #093179;

}
`, "",{"version":3,"sources":["webpack://./src/components/Forms/Forms.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yDAAyD;EACzD,sCAAsC;EACtC,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;;;EAGE,WAAW;AACb;AACA;;EAEE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,kCAAkC;IAClC,SAAS;IACT,8BAA8B;EAChC;EACA;IACE,WAAW;EACb;EACA;;IAEE,sBAAsB;EACxB;AACF;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;;AAEhB","sourcesContent":[".form-wrapper {\n  width: 70%;\n  padding-bottom: 9rem;\n  padding-top: 5rem;\n  position: relative;\n}\n.form-outer-wrapper {\n  width: 70%;\n  margin-top: 3rem;\n}\n.form-outer-wrapper form {\n  width: 100%;\n}\n.form-wrapper form .row {\n  margin-bottom: 3rem;\n}\n.form-wrapper form .row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n}\n.form-field {\n  display: flex;\n  flex-direction: column;\n  row-gap: 1rem;\n  column-gap: 4rem;\n  position: relative;\n}\n.form-field select{\n  -webkit-appearance: none;\n}\n.form-field select {\n  background-image: url('./../../assets/DropDownArrow.svg');\n  background-position: right 10px center;\n  background-repeat: no-repeat;          \n  background-size: 10px 6px;             \n}\n.name,\n.email,\n.country {\n  width: 100%;\n}\n.form-wrapper form .row:nth-child(3) > div,\n.form-wrapper form .row:nth-child(4) > div {\n  width: 48%;\n}\n.heading-inner {\n  margin-top: 2.5rem;\n}\n.heading-inner h2 {\n  font-size: 2.2rem;\n  font-weight: 500;\n}\n.questions-wrapper {\n  padding: 3rem 0;\n  overflow-y: auto;\n  height: 66%;\n}\n.schedule-demo-wrapper {\n  height: 100%;\n}\n.schedule-demo-top {\n  display: flex;\n  border-bottom: 1px solid #9a9a9a33;\n}\n.schedule-demo-left {\n  width: 74%;\n}\n.schedule-demo-right {\n  width: 26%;\n  margin-top: 1rem;\n}\n@media (min-width: 1850px) {\n  .form-outer-wrapper form {\n    width: 70%;\n  }\n}\n@media (max-width: 1440px) {\n  .schedule-demo-left {\n    width: 72%;\n  }\n  .schedule-demo-right {\n    width: 28%;\n  }\n  .form-wrapper {\n    width: 68%;\n  }\n  .form-outer-wrapper {\n    width: 80%;\n  }\n}\n@media (max-width: 1024px) {\n  .schedule-demo-top {\n    flex-direction: column;\n  }\n  .schedule-demo-left {\n    width: 100%;\n  }\n  .schedule-demo-top {\n    padding-bottom: 2rem;\n  }\n  .schedule-demo-right {\n    width: 100%;\n    margin-top: 0;\n  }\n  .form-outer-wrapper {\n    width: 88%;\n  }\n}\n\n@media (max-width: 768px) {\n  .form-wrapper {\n    margin-top: 3rem;\n    width: 100%;\n    padding-top: 0;\n  }\n\n  .form-outer-wrapper .row {\n    flex-direction: column;\n    align-items: flex-start !important;\n    gap: 2rem;\n    margin-bottom: 2rem !important;\n  }\n  .form-outer-wrapper {\n    width: 100%;\n  }\n  .form-outer-wrapper .row:nth-child(3) > div,\n  .form-outer-wrapper .row:nth-child(4) > div {\n    width: 100% !important;\n  }\n}\n.loader-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n.timezone-wrapper {\n  margin: 3rem;\n  padding: 20px;\n  border: 1px solid #093179;\n  text-align: center;\n  padding: 14px 8px;\n  border-radius: 12px;\n}\n.timezone-wrapper p {\n  font-weight: 600;\n  color: #093179;\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
